























































































































































































# import settings from '@/settings'
import n from '@/utils/notifications'
import t from '@/utils/tools'
import q from '@/graphql/query'
import m from '@/graphql/mutation'

export default {
    name: 'company_recruitments_edition'
    props:
        uid: {
            type: String
            required: false
            default: ''
        }

    data: ()->
        errors: {}
        jobs: []
        selected_job_uid: ''
        clearable: true
        loading: true
        activities: {}
        knowledges: {}
        qualities: {}
        skills: {}
        capacitations: {}
        recruitment: {
            uid: ''
            job_uid: ''
            content: ''
            experience_level: {uid:''}
            experience_mandatory: 0
            experience_domains: ''
            graduate_level: {uid:''}
            graduate_mandatory: 0
            graduate_domains: ''
            pay_from: ''
            pay_to: ''
            bonus: ''
            advantages: ''
            status: {uid:''}
            context: ''
            days_variable: 0
            hours_variable: 0
            location: ''
            trips_frequency: 0
            trips_zone: 0
            active: 1
        }
        graduate_level_choice_set: @$store.state.graduate_level_choice_set
        experience_level_choice_set: []
        status_choice_set: @$store.state.employee_status_choice_set

    computed:
        readonly: ()->
            return !t.has_access_right('recruitments_edit')

    methods:
        get_errors: (fieldName)->
            ret = null
            if @errors[fieldName]?
                ret = @errors[fieldName][0]
            return ret

        get_recruitment: (recruitment_uid)->
            self = @
            q.run('get_recruitment', [recruitment_uid])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("company_recruitments_edition: get_recruitment: then", e.message)
                else
                    # console.log "GET ONE RECRUITMENT : ", resp.body.data.recruitment
                    r = resp.body.data.recruitment
                    if r.content?
                        r.content = r.content.replace(/\n/g, '\n')
                    if r.experience_level == null
                        r.experience_level = {uid:''}
                    if r.graduate_level == null
                        r.graduate_level = {uid:''}
                    if r.status == null
                        r.status = {uid:''}
                    self.recruitment = r
                    self.selected_job_uid = self.recruitment.job.uid
                    self.get_job_skills()
            .catch (resp)->
                n.catch_error(resp, "company_recruitments_edition: get_recruitment()")

        get_jobs: ()->
            @loading = true
            self = @
            q.run('get_recruitments_job_set', [@$store.getters.current_company.uid])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("company_recruitments_edition: get_jobs: then", e.message)
                else
                    # console.log "RUN QUERY JOBS : ", resp.body.data.recruitments_job_set
                    self.jobs = resp.body.data.recruitments_job_set
                    self.loading = false
            .catch (resp)->
                n.catch_error(resp, "company_recruitments_edition: get_jobs()")

        get_job_skills: ()->
            self = @
            q.run('get_recruitments_job_skill_set', [@selected_job_uid])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("company_recruitments_edition: get_job_skills: then", e.message)
                else
                    # console.log "RUN QUERY JOB SKILLS : ", resp.body.data.recruitments_job_skill_set
                    self.activities = resp.body.data.recruitments_job_skill_set.filter (x)-> x.skill_type == 'activity'
                    self.knowledges = resp.body.data.recruitments_job_skill_set.filter (x)-> x.skill_type == 'knowledge'
                    self.qualities = resp.body.data.recruitments_job_skill_set.filter (x)-> x.skill_type == 'quality'
                    self.skills = resp.body.data.recruitments_job_skill_set.filter (x)-> x.skill_type == 'skill'
                    self.capacitations = resp.body.data.recruitments_job_skill_set.filter (x)-> x.skill_type == 'capacitation'
                    # console.log "RUN QUERY ACTIVITIES : ", self.activities
            .catch (resp)->
                n.catch_error(resp, "company_recruitments_edition: get_job_skills()")

        get_experience_level_choice_set: ()->
            self = @
            @errors = {}
            q.run('get_type_set', ['experience_level_choice'])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("company_recruitments_edition: get_experience_level_choice_set: then" ,e.message)
                else
                    # console.log "GET EXPERIENCE LEVEL CHOICES : ", resp.body.data.experience_level_choice_set
                    self.experience_level_choice_set = resp.body.data.experience_level_choice_set
            .catch (resp)->
                n.catch_error(resp, "company_recruitments_edition: get_experience_level_choice_set()")

        set_selected_job_uid: ()->
            if @selected_job_uid != ''
                @get_job_skills()
                for j in @jobs
                    if j.uid == @selected_job_uid
                        if j.graduate_level == null
                            @recruitment.graduate_level = {uid:''}
                        else
                            @recruitment.graduate_level = j.graduate_level
                        break
            # console.log "JOB SELECTED", @selected_job_uid

        save: ()->
            @recruitment.job_uid = @selected_job_uid
            # console.log "RECRUITMENT EDITION SAVE", @recruitment
            if @selected_job_uid == ''
                n.file_error('Formulaire', 'Vous devez choisir une fiche métier')
                return
            self = @
            m.run('save_recruitment', [@recruitment])
            .then (resp)->
                if resp.body.data.recruitment_form_mutation.form_ret == 'failed'
                    return n.access_denied()
                if resp.body.data.recruitment_form_mutation.errors.length > 0
                    # console.log "ERRORS", resp.body.data.recruitment_form_mutation.errors
                    self.errors = resp.body.data.recruitment_form_mutation.errors.reduce(
                        (acc, el)->
                            acc[el.field] = el.messages
                            return acc
                    ,{})
                    n.form_error()
                else
                    self.errors = {}
                    n.success()
                    # console.log "RECRUITMENT SAVED ", resp.body.data.recruitment_form_mutation.form_ret, self.recruitment.uid
                    if self.recruitment.uid == ''
                        self.$router.push({ name: 'company_recruitments_edition', params: { uid: resp.body.data.recruitment_form_mutation.form_ret } })
                        self.recruitment.uid = resp.body.data.recruitment_form_mutation.form_ret
                        self.get_recruitment(resp.body.data.recruitment_form_mutation.form_ret)
                        self.get_jobs()
            .catch (resp)->
                n.catch_error(resp, "company_recruitments_edition: save()")
        
    beforeMount: ()->
        @get_experience_level_choice_set()
        # console.log "RECRUITMENTS EDITION", @uid, typeof(@uid), @recruitment, @selected_job_uid
        if @uid != '0'
            @get_recruitment(@uid)
        @get_jobs()
}
